"use client";



export default function Canvas() {
  return (
    <section className="w-full flex flex-col items-center bg-card p-4 rounded-lg relative min-h-[200px] text-4xl">
      {/* USA 1 Connection Link */}
      {/* Subtle Disclaimer at the bottom */}
      <div className="w-full flex justify-center absolute bottom-4 left-0">
        <p className="text-2xl text-muted-foreground font-medium">
          Please send the exact amount the shopping cart shows.
        </p>
      </div>
    </section>
  );
}
